import ToggleComponent from './components/Toggle'
import SelectComponent from './components/Select'

export default {
  toggle: ToggleComponent,
  select: SelectComponent
}
